import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import decodeToken from 'utils/DecodeToken';


const ProtectedRoute = () => {
    const userInfo = decodeToken();

    let isLoggedInValue = false;

    if (userInfo) {
        try {
            isLoggedInValue = userInfo.isAuth;
        } catch (error) {
            console.error('Error parsing userInfo:', error);
        }
    }
    return isLoggedInValue ? <Outlet /> : <Navigate to='/sign-in' replace />;
}

export default ProtectedRoute;